module.exports = __webpack_public_path__ + "img/icon-close.478d344d.svg";